import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../src/config/authAxios"



const initialState = { status: null, message: "", loading: false, data: [], error: "" }


export const exitMissionAction = createAsyncThunk(
    'exit-mission',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.post(`/users/api/mission/quit`,{mission_id:data})
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const exitMissionSlice = createSlice({
    name: 'exit-mission',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(exitMissionAction.pending, (state) => {
                state.data = []
                state.loading = true
            })
            builder.addCase(exitMissionAction.fulfilled, (state, action) => {
                state.data = action.payload.data
                state.loading = false
                state.message = action.payload.message
                state.status = action.payload.status
            })
            builder.addCase(exitMissionAction.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload.error
                state.message = action.payload.message
                state.status = action.payload.status
            })
        },

})



export const exitMissionReducer = exitMissionSlice.reducer